import { forwardRef, type Ref, type SVGProps } from "react";
const IconThumbsDownFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M23.45 25.54c0-2.31-1.07-4-1.45-5.54h5a2.81 2.81 0 0 0 3-2.81 4 4 0 0 0-1-2.68 4.88 4.88 0 0 0-.47-4.35 4.57 4.57 0 0 0-.84-4.09 3.1 3.1 0 0 0-.32-2.45C26.34 2 23.74 2 21.55 2h-.14a14 14 0 0 0-6.11 1.73 7.9 7.9 0 0 1-2.69.89.63.63 0 0 0-.61.65V17a.7.7 0 0 0 .18.46c2 2.14 2.9 4.41 4.56 6.19A6.86 6.86 0 0 1 18 26.84c.23 1 .7 3.16 1.74 3.16 1.26 0 3.71-.44 3.71-4.46M9 16V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2M6.51 5.5a1 1 0 1 1-1-1 1 1 0 0 1 1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconThumbsDownFilledSVG);
ForwardRef.displayName = "IconThumbsDownFilled";
export { ForwardRef as IconThumbsDownFilled };
